import { DocumentType } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";

export class DocumentsListRequest{
    @ApiProperty()
    saleOrderId:number;
    @ApiProperty()
    documentCategory:string;
    @ApiProperty()
    file:string[];
    @ApiProperty()
    documentType:DocumentType;
    constructor(saleOrderId:number, documentCategory:string, file:string[],documentType:DocumentType){
        this.saleOrderId = saleOrderId;
        this.documentCategory = documentCategory;
        this.file = file;
        this.documentType = documentType;
    }
}